import React, { ReactNode } from "react"


export const FlexContainerRow = ({children}:{children?: ReactNode}) => {

    return (
        <div style={{display: "flex", gap: "8px", flexDirection: "row"}}>
            {children}
        </div>
    )
}